import { useEffect } from "react";
import CircleSpinner from "src/components/CircleSpinner";
import EmptyPage from "src/components/EmptyPage";
import config from "src/config";

export const Loading = ({ name }: { name?: string }) => {
  useEffect(() => {
    if (config.isLocal && name) {
      console.log("Loading spinner", name);
    }
  }, [name]);

  return (
    <EmptyPage className="centered simple-padded">
      <CircleSpinner />
    </EmptyPage>
  );
};
